import React from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import { DATA_SOURCE } from "../../../../../util/Data/DataModeling";

const ApplyWarning = (props) => {
  const { sources, entities, objectType } = props;

  return (
    <Box sx={{ fontSize: "0.875rem" }}>
      <>{`These objects are in relation with this ${
        objectType === "sources" ? "data-source" : "entity"
      }. Applying it will also apply below listed objects as well.`}</>
      {sources && sources.length > 0 && (
        <div style={{ paddingTop: "4px", margin: 0 }}>
          <>{`${DATA_SOURCE.plural} - `}</>
          <ul>
            {sources.map(({ id, name, displayName }) => (
              <li key={id}>{`${displayName}(${name})`}</li>
            ))}
          </ul>
        </div>
      )}
      {entities && entities.length > 0 && (
        <div style={{ paddingTop: "4px", margin: 0 }}>
          <>Entities - </>
          <ul>
            {entities.map(({ id, name, displayName }) => (
              <li key={id}>{`${displayName}(${name})`}</li>
            ))}
          </ul>
        </div>
      )}
    </Box>
  );
};

ApplyWarning.propTypes = {
  sources: PropTypes.array.isRequired,
  entities: PropTypes.array.isRequired,
  objectType: PropTypes.string.isRequired,
};

export default React.memo(ApplyWarning);
